module.exports = "<ng-container>\n    <div  class=\"d-flex align-items-center\">\n        <span class=\"d-flex mr-3\" *ngIf=\"dossier.numeroRequete || dossier.numeroRequeteProvisoire\">{{ dossier.numeroRequete || dossier.numeroRequeteProvisoire + '*' }}</span>\n        <span class=\"d-flex mr-3\" *ngIf=\"!dossier.numeroRequete && !dossier.numeroRequeteProvisoire\"></span>\n    </div>\n    <div> {{dossier.titre}} </div>\n</ng-container>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/home/mes-dossiers/numero-dossier/numero-dossier.component.html
// module id = 806
// module chunks = 0